// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__aYn7_","navText":"Navbar_navText__1fHAd","navLogo":"Navbar_navLogo__5xm5z","imgLogo":"Navbar_imgLogo__16B9C"};